import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseTextContent,
  BaseForm,
  BaseFormItem,
  BaseDialog,
  BaseButton,
  XrkMessage,
  BaseInputNumber,
  BaseUpload
} from 'xrk-components';
import { proxyTaxFile } from '../../data-source/apis';
import { uploadApi } from '@data-source/common/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-djsj-audit-dialog',
  props: {
    remove: {},
    id: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const formRef = ref();
const formData = ref<{ fileList: any; proxyTaxAmount: number }>({
  fileList: [],
  proxyTaxAmount: null
});

const formRules = {
  proxyTaxAmount: [
    {
      required: true,
      trigger: 'change',
      message: '请填写代缴税金',
      validator: (rule, v, callback) => {
        if (v <= 0) {
          return callback(new Error('请输入大于0的金额'));
        }
        callback();
      }
    }
  ],
  fileList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length || v.some(item => !item.url)) {
          return callback(new Error('请重新上传资料'));
        }
        callback();
      }
    }
  ]
};

const onPreviewFile = file => {
  if (file.url) {
    window.open(file.url, '_blank');
  }
};
/**
 * @description: 确认提交
 */
const onPass = async () => {
  await formRef.value.validate();
  // 代缴税金单位转换（元→分）统一在数据源层 proxyTaxFile 内处理
  await proxyTaxFile({
    id: props.id,
    proxyTaxAmount: formData.value.proxyTaxAmount,
    fileList: formData.value.fileList
  });
  XrkMessage.success('提交成功');
  emits('success');
  props.remove();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "500px",
    title: "审核",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        onClick: onPass
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认提交")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-position": "right",
            rules: formRules,
            model: formData.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "代缴税金",
                prop: "proxyTaxAmount"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInputNumber), {
                    controls: false,
                    precision: 2,
                    min: 0.01,
                    max: 999999999,
                    modelValue: formData.value.proxyTaxAmount,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.proxyTaxAmount) = $event))
                  }, {
                    append: _withCtx(() => [
                      _createTextVNode("元")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "上传附件",
                prop: "fileList"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseUpload), {
                    style: {"margin-bottom":"20px"},
                    btnText: "上传",
                    tipText: "支持上传 word/xls/xlsx/pdf/.rar/.zip/.7z/jpg/png 文件，且不超过500M",
                    autoUpload: "",
                    listType: "text",
                    accept: [
              '.jpg',
              '.jpeg',
              '.png',
              '.word',
              '.xls',
              '.pdf',
              '.rar',
              '.zip',
              '.7z'
            ],
                    limit: 10,
                    limitSize: 500,
                    multiple: false,
                    "http-request": _unref(uploadApi),
                    fileList: formData.value.fileList,
                    "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.fileList) = $event)),
                    onPreview: onPreviewFile
                  }, null, 8, ["http-request", "fileList"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})